const createImageObjects = (data: any) => {
  let image = {};
  let updatedImage = {};
  const prop = `image`;
  if (data[prop]) {
    if (data[prop].file) {
      image = data[prop].file;
      updatedImage = {
        index: 0,
        name: data[prop].file.name,
        is_main_image: data[prop].is_main_image,
      };
    } else if (data[prop].image === undefined) {
      updatedImage = {
        index: 0,
        name: undefined,
        is_main_image: data[prop].is_main_image,
      };
    }
  }

  return { image, updatedImage };
};

export const createBannerObj = (data: any) => {
  let { image, updatedImage } = createImageObjects(data);
  return {
    image,
    updatedImage,
    is_active: data["is_active"],
    title: data["title"],
    link: data["link"],
  };
};
